import React from "react";
import './TreatmentPlan.css';

interface ITreatmentPlanProps{
    onClose: ()=>void;
}

export const TreatmentPlan = ({onClose}: ITreatmentPlanProps)=>{
    return (
        <div className="TreatmentPlan">
            <div className="TreatmentPlan_form">
                <div className="TreatmentPlan_header">
                    <div className="TreatmentPlan_title">
                        Treatment plan
                    </div>
                    <div className="addSession_icon addSession_close_icon" onClick={onClose}></div>
                </div>
            </div>
        </div>
    )
}